module.exports = __webpack_public_path__ + "static/media/mdi_help_outline.4e13269e.svg";